import { __decorate } from "tslib";
import { Component, Vue, Prop, } from "vue-property-decorator";
let TabsContent = class TabsContent extends Vue {
    tabsClick(val) {
        this.$emit("change", val);
    }
};
__decorate([
    Prop({
        default: () => {
            return [];
        },
        type: Array,
    })
], TabsContent.prototype, "tabsList", void 0);
__decorate([
    Prop({ default: "" })
], TabsContent.prototype, "tabsActive", void 0);
__decorate([
    Prop({ default: "" })
], TabsContent.prototype, "type", void 0);
TabsContent = __decorate([
    Component({
        components: {},
    })
], TabsContent);
export default TabsContent;
